import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Initialize with actual viewport state instead of undefined
  const getIsMobile = () => typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
  const [isMobile, setIsMobile] = React.useState(getIsMobile)

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    const handleMediaChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }
    
    const handleResize = () => {
      const mobile = getIsMobile()
      setIsMobile(mobile)
    }
    
    // Add both listeners for maximum DevTools compatibility
    mediaQuery.addEventListener('change', handleMediaChange)
    window.addEventListener('resize', handleResize)
    
    // Set initial state and log it
    const initialMobile = getIsMobile()
    setIsMobile(initialMobile)
    
    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isMobile
}
